<template>
    <div>
        <title-component></title-component>
        <b-form>
            <div class="row">
                <div class="col-12 col-sm-12">
                    <card-title-component :title="$t('documents.generalDocs.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col general-docs-item">
                                <input id="documentInput" ref="documentInput" type="file" style="visibility:hidden"
                                       @change="fileChosen"/>
                                <div v-for="document in documents.generalDocs" :key="document.id">
                                    <a href="javascript:void(0)" v-on:click="download(document.id, document.name)">
                                        <icon name="file-o"></icon>
                                        {{document.name}}
                                    </a>
                                    <a href="javascript:void(0)" v-on:click="deleteDocument(document.id)">
                                        <icon name="trash-o"></icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="add-link">
                                    <a href="javascript:void(0)" @click="openInput('document')">
                                        {{$t('documents.addDocumentButton')}}
                                    </a>
                                    <span class="popover-trigger"
                                          v-b-popover.hover="$t('documents.popover')">
                                        <icon name="info-circle"></icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        DOCUMENTS_ACTION_GET_DOCUMENTS,
        DOCUMENTS_ACTION_UPLOAD_FILE,
        DOCUMENTS_ACTION_DELETE_FILE,
        DOCUMENTS_GETTER,
        DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS,
        DOCUMENTS_NAMESPACE,
        DOCUMENTS_TYPE_GENERAL_DOCUMENT
    } from '../store/modules/documents-types'
    import TitleComponent from './shared/TitleComponent'
    import CardTitleComponent from './ui/card/CardTitleComponent'
    import FileUploadComponent from './funeral/FileUploadComponent'
    import i18n from '../assets/i18n/lang'
    import Icon from 'vue-awesome/components/Icon'
    import 'vue-awesome/icons/file-o'
    import 'vue-awesome/icons/info-circle'
    import API from '../services/API'
    import config from '../assets/data/siteconfig'
    import OAlert from '../utils/OAlert/OAlert'

    export default {
        name: 'Documents',
        metaInfo () { return {title: i18n.t('documents.meta')} },
        components: {
            'title-component': TitleComponent,
            'card-title-component': CardTitleComponent,
            'file-upload-component': FileUploadComponent,
            'icon': Icon
        },
        computed: {
            ...mapGetters(DOCUMENTS_NAMESPACE, {
                documents: DOCUMENTS_GETTER
            })
        },
        methods: {
            ...mapMutations(DOCUMENTS_NAMESPACE, {
                updateDocuments: DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS
            }),
            ...mapActions(DOCUMENTS_NAMESPACE, {
                loadDocuments: DOCUMENTS_ACTION_GET_DOCUMENTS,
                uploadFile: DOCUMENTS_ACTION_UPLOAD_FILE,
                deleteFile: DOCUMENTS_ACTION_DELETE_FILE
            }),
            openInput (type) {
                this.$refs.documentInput.click()
            },
            fileChosen (event) {
                let contentType = this.$refs.documentInput.files[0].type.replace('application/', '')
                contentType = contentType.replace('image/', '')
                if ((config.validDocFileTypes.indexOf(contentType) > -1) ||
                    (config.validPhotoFileTypes.indexOf(contentType) > -1) ||
                    (config.validVideoFileTypes.indexOf(contentType) > -1)) {
                    this.uploadFile({
                        filename: this.$refs.documentInput.files[0].name,
                        file: this.$refs.documentInput.files[0],
                        type: DOCUMENTS_TYPE_GENERAL_DOCUMENT
                    })
                } else {
                    OAlert.showFailure('', i18n.t('feedback.filetypeFailUpload01') + contentType + i18n.t('feedback.filetypeFailUpload02'))
                }
            },
            download (id, docName) {
                API.downloadGenDocFromBackend(id)
                    .then((data) => {
                        return this.insertDownloadlink(data, docName)
                    })
                    .catch((error) => console.log(error.message))
            },
            insertDownloadlink (data, docName) {
                return new Promise(
                    (resolve, reject) => {
                        window.URL = window.URL || window.webkitURL
                        const link = document.createElement('a')
                        link.href = window.URL.createObjectURL(new Blob([data], {type: data.type}))
                        link.setAttribute('download', docName)
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        resolve()
                    }
                )
            },
            deleteDocument (id) {
                this.deleteFile({
                    id: id,
                    type: DOCUMENTS_TYPE_GENERAL_DOCUMENT
                })
            }
        },
        created () {
            this.loadDocuments()
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }

    .add-link {
        padding-top: 40px;
        text-align: right;
        /*text-decoration: underline;*/
    }

    .general-docs-item {
        text-align: left;
    }

    span.popover-trigger {
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/DocumentsComponent.vue